import styled from "@emotion/styled";

export const Content = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-end;
`;
